var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7539 4.89197L12.0664 7.00134L20.293 17.3373C20.5742 17.6888 20.75 18.1107 20.75 18.5677V19.3763C20.75 20.3256 19.9766 21.0638 19.0625 21.0638H10.625H2.1875C1.23828 21.0638 0.5 20.3256 0.5 19.3763V18.5677C0.5 18.1107 0.640625 17.6888 0.921875 17.3373L9.18359 7.00134L7.49609 4.89197C7.10938 4.43494 7.17969 3.69666 7.67188 3.30994C8.12891 2.92322 8.86719 3.02869 9.25391 3.48572L10.625 5.20837L11.9961 3.48572C12.3828 3.02869 13.0859 2.92322 13.5781 3.30994C14.0352 3.73181 14.1406 4.43494 13.7539 4.89197ZM10.625 18.8138H14.8086L10.625 13.3295L6.40625 18.8138H10.625Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default ForwardRef;